function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M21.5116005,0H3.1199999C1.39579,0,0,1.41959,0,3.1731999v7.0144005 c0,1.7536001,1.39579,3.1731997,3.1199999,3.1731997h4.46105c0.8484201,0,1.6147404-0.4453001,2.0526304-1.1689997 L11.0021,8.5175304c0.4652996-1.2525806,2.2167997-1.2525806,2.6821003,0l1.3683996,3.6742697 c0.4379005,0.7236996,1.2041998,1.1689997,2.052701,1.1689997h4.4609985c1.6695004,0,3.0653-1.4195995,3.0653-3.1731997V3.1731999 C24.6315994,1.41959,23.2357998,0,21.5116005,0z M6.1305299,8.5732002C4.95368,8.5732002,3.99579,7.5989699,3.99579,6.40206 s0.95789-2.1711302,2.1347399-2.1711302c1.1768403,0,2.1347299,0.9742203,2.1347299,2.1711302 S7.3347402,8.5732002,6.1305299,8.5732002z M18.7199993,8.5732002c-1.1767998,0-2.1346989-0.9742303-2.1346989-2.1711402 s0.9578991-2.1711302,2.1346989-2.1711302s2.1347008,0.9742203,2.1347008,2.1711302S19.9242001,8.5732002,18.7199993,8.5732002z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25px",
    height: "14px",
    viewBox: "0 0 25 14",
    style: {
      "enableBackground": "new 0 0 25 14"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/vr-glasses.f321e8cc.svg";
export { SvgComponent as ReactComponent };